<template>
  <div class="occurrence-page">
    <!-- Mapa fullscreen -->
    <GmapMap
      ref="mapRef"
      :center="mapCenter"
      :zoom="13"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      @click="onMapClick"
    >
      <GmapMarker
        v-for="occ in mapOccurrences"
        :key="'occ-' + occ.id"
        :position="{ lat: occ.latitude, lng: occ.longitude }"
        :title="occ.requester_name"
        :icon="getMarkerIcon(occ)"
        :label="getMarkerLabel(occ)"
        @click="
          selectedMapOcc = occ;
          showInfoWindow = true;
          infoWindowPos = { lat: occ.latitude, lng: occ.longitude };
        "
      />
      <GmapMarker
        v-if="form.latitude && form.longitude"
        :position="{
          lat: parseFloat(form.latitude),
          lng: parseFloat(form.longitude),
        }"
        :draggable="true"
        @dragend="onMarkerDrag"
      />
      <GmapMarker
        v-for="poi in visiblePois"
        :key="'poi-' + poi.id"
        :position="{ lat: parseFloat(poi.latitude), lng: parseFloat(poi.longitude) }"
        :title="poi.name"
        :icon="getPoiMarkerIcon(poi)"
        @click="openPoiModal(poi)"
      />
      <GmapInfoWindow
        :options="{ maxWidth: 340 }"
        :position="infoWindowPos"
        :opened="showInfoWindow"
        @closeclick="showInfoWindow = false"
      >
        <div
          v-if="selectedMapOcc"
          style="font-size: 13px; min-width: 280px; line-height: 1.6"
        >
          <!-- Cabeçalho -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 6px;
            "
          >
            <strong style="font-size: 14px">{{
              selectedMapOcc.requester_name
            }}</strong>
            <span
              :style="{
                display: 'inline-block',
                padding: '1px 8px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: 'bold',
                background: selectedMapOcc.status == 1 ? '#d4edda' : '#f8d7da',
                color: selectedMapOcc.status == 1 ? '#155724' : '#721c24',
              }"
              >{{
                selectedMapOcc.status == 1
                  ? $t("occurrence.map.open")
                  : $t("occurrence.map.closed")
              }}</span
            >
          </div>

          <!-- Protocolo e tempo -->
          <div style="color: #666; font-size: 11px; margin-bottom: 6px">
            <span v-if="selectedMapOcc.protocol"
              >#{{ selectedMapOcc.protocol }} &bull;
            </span>
            {{ $t("occurrence.map.open") }}
            {{ timeAgo(selectedMapOcc.created_at) }}
          </div>

          <hr style="margin: 4px 0 6px; border-color: #eee" />

          <!-- Endereço -->
          <div v-if="selectedMapOcc.address" style="margin-bottom: 4px">
            <b>{{ $t("occurrence.map.addressLabel") }}</b>
            {{ selectedMapOcc.address
            }}{{ selectedMapOcc.number ? ", " + selectedMapOcc.number : ""
            }}{{
              selectedMapOcc.complement
                ? " - " + selectedMapOcc.complement
                : ""
            }}<br />
            <span v-if="selectedMapOcc.neighborhood" style="color: #555">
              {{ selectedMapOcc.neighborhood
              }}{{ selectedMapOcc.city ? " - " + selectedMapOcc.city : ""
              }}{{ selectedMapOcc.state ? "/" + selectedMapOcc.state : "" }}
            </span>
          </div>

          <!-- Telefone -->
          <div v-if="selectedMapOcc.requester_phone" style="margin-bottom: 4px">
            <b>{{ $t("occurrence.map.phoneLabel") }}</b>
            {{ selectedMapOcc.requester_phone }}
          </div>

          <hr style="margin: 4px 0 6px; border-color: #eee" />

          <!-- Disciplina / Tipo / Motivo -->
          <div v-if="selectedMapOcc.discipline" style="margin-bottom: 2px">
            <b>{{ $t("occurrence.map.disciplineLabel") }}</b>
            {{ selectedMapOcc.discipline }}
          </div>
          <div v-if="selectedMapOcc.dispatch_type" style="margin-bottom: 2px">
            <b>{{ $t("occurrence.map.typeLabel") }}</b>
            {{ selectedMapOcc.dispatch_type }}
          </div>
          <div v-if="selectedMapOcc.dispatch_reason" style="margin-bottom: 2px">
            <b>{{ $t("occurrence.map.reasonLabel") }}</b>
            {{ selectedMapOcc.dispatch_reason }}
          </div>

          <!-- Veículos atendendo -->
          <div
            v-if="
              selectedMapOcc.attending_vehicles &&
              selectedMapOcc.attending_vehicles.length
            "
            style="margin-top: 4px"
          >
            <hr style="margin: 4px 0 6px; border-color: #eee" />
            <b>{{ $t("occurrence.map.attendingVehiclesLabel") }}</b>
            <div
              v-for="(v, idx) in selectedMapOcc.attending_vehicles"
              :key="idx"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 2px;
              "
            >
              <span>
                {{ v.vehicle_name || v.team_name }}
                <small v-if="v.arrived_at" style="color: #888; display: block">
                  {{ $t("occurrence.map.arrivedAtLabel") }} {{ v.arrived_at | date }}
                </small>
              </span>
              <span
                v-if="v.status_code"
                :title="v.status_name"
                style="
                  background: #e7f1ff;
                  color: #1a58a8;
                  border-radius: 10px;
                  padding: 1px 8px;
                  font-size: 11px;
                  font-weight: bold;
                "
                >{{ v.status_code }}</span
              >
            </div>
          </div>

          <!-- Hospital de destino -->
          <div
            v-if="
              selectedMapOcc.destination_establishments &&
              selectedMapOcc.destination_establishments.length
            "
            style="margin-top: 4px"
          >
            <hr style="margin: 4px 0 6px; border-color: #eee" />
            <b>{{ $t("occurrence.map.destinationLabel") }}</b>
            {{ selectedMapOcc.destination_establishments.join(", ") }}
          </div>

          <!-- Queixa -->
          <div
            v-if="selectedMapOcc.complaint"
            style="
              margin-top: 6px;
              padding: 5px 7px;
              background: #f8f9fa;
              border-radius: 4px;
              font-style: italic;
              color: #444;
            "
          >
            "{{ selectedMapOcc.complaint }}"
          </div>

          <!-- Quem abriu -->
          <div
            v-if="selectedMapOcc.created_by"
            style="margin-top: 6px; color: #888; font-size: 11px"
          >
            {{ $t("occurrence.map.openedBy") }} {{ selectedMapOcc.created_by }}
          </div>
        </div>
      </GmapInfoWindow>
    </GmapMap>

    <!-- Menu flutuante do mapa -->
    <div ref="mapMenu" class="map-menu">
      <button
        type="button"
        class="map-menu-toggle"
        :class="{ 'is-on': !!mapLabelField }"
        @click="toggleMapMenu"
      >
        <feather-icon icon="MenuIcon" size="14" />
        <span>{{ $t("occurrence.mapMenu.features") }}</span>
      </button>

      <div v-if="mapMenuOpen" class="map-menu-panel">
        <button type="button" class="map-menu-item" @click="fitAllOccurrences">
          <feather-icon icon="MaximizeIcon" size="14" />
          <span>{{ $t("occurrence.mapMenu.centerAll") }}</span>
        </button>

        <button
          type="button"
          class="map-menu-item"
          :class="{ 'is-on': !!mapLabelField }"
          @click="labelMenuOpen = !labelMenuOpen"
        >
          <feather-icon icon="TagIcon" size="14" />
          <span>{{ $t("occurrence.mapMenu.label") }}</span>
          <feather-icon
            :icon="labelMenuOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="13"
            class="map-menu-caret"
          />
        </button>

        <div v-if="labelMenuOpen" class="map-menu-sub">
          <button
            v-for="option in mapLabelOptions"
            :key="option.field"
            type="button"
            class="map-menu-sub-item"
            :class="{ 'is-active': mapLabelField === option.field }"
            @click="setMapLabelField(option.field)"
          >
            {{ option.label }}
          </button>

          <button
            v-if="mapLabelField"
            type="button"
            class="map-menu-sub-item is-clear"
            @click="setMapLabelField(null)"
          >
            {{ $t("occurrence.mapMenu.clearLabel") }}
          </button>
        </div>

        <button
          type="button"
          class="map-menu-item"
          :class="{ 'is-on': showPois }"
          @click="togglePois"
        >
          <feather-icon icon="MapPinIcon" size="14" />
          <span>{{ $t("occurrence.mapMenu.showPois") }}</span>
        </button>
      </div>
    </div>

    <!-- Painel flutuante esquerdo -->
    <div class="occ-panel">
      <div class="occ-panel__header">
        <span
          v-if="creatingOccurrence"
          class="occ-panel__title occ-panel__title--creating"
        >
          <feather-icon icon="LoaderIcon" size="15" class="mr-25" />
          {{ $t("occurrence.panel.opening") }}
        </span>
        <div v-else-if="phoneCreateError" class="occ-open-error">
          <span class="occ-open-error__msg">
            <feather-icon icon="AlertTriangleIcon" size="14" class="mr-25" />
            {{ $t("occurrence.panel.openFailed") }}
          </span>
          <button
            type="button"
            class="occ-open-error__retry"
            @click="retryOpenOccurrence"
          >
            <feather-icon icon="RefreshCwIcon" size="12" class="mr-25" />
            {{ $t("occurrence.panel.retry") }}
          </button>
        </div>
        <span
          v-else-if="currentProtocol"
          class="occ-panel__title occ-panel__title--open"
        >
          <feather-icon icon="AlertCircleIcon" size="15" class="mr-25" />
          {{
            $t("occurrence.panel.protocolTitle", { protocol: currentProtocol })
          }}
          <span
            v-if="currentOccurrenceCreatedAt"
            :class="[
              elapsedBadgeClass(
                currentOccurrenceCreatedAt,
                'solicita',
                form.discipline_id
              ),
              'ml-1',
            ]"
            style="font-size: 0.78em; vertical-align: middle"
          >
            {{ elapsedHHMMSS(currentOccurrenceCreatedAt) }}
          </span>
        </span>
        <h5 v-else class="mb-0">{{ $t("occurrence.panel.newOccurrence") }}</h5>
      </div>
      <div
        ref="panelBody"
        class="occ-panel__body"
        @scroll.passive="onPanelScroll"
      >
        <div class="form-group phone-field-wrap">
          <label
            ><span class="required">*</span>
            {{ $t("occurrence.panel.phoneLabel") }}</label
          >
          <div class="phone-input-wrap">
            <input
              ref="phoneInput"
              v-model="form.requester_phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              type="text"
              :class="[
                'form-control',
                errors.requester_phone || (phoneHistory && phoneHistory.total > 0)
                  ? 'is-invalid'
                  : '',
                phoneHistory && phoneHistory.total > 0 ? 'has-trote-icon' : '',
              ]"
              placeholder="(00) 00000-0000"
              @blur="onPhoneBlur"
            />
            <feather-icon
              v-if="phoneHistory && phoneHistory.total > 0"
              icon="AlertCircleIcon"
              size="18"
              class="phone-trote-icon"
              :title="$t('occurrence.phone.suspiciousTitle')"
            />
          </div>
          <transition name="phone-balloon-fade">
            <div
              v-if="
                phoneHistory && phoneHistory.total > 0 && !phoneHistoryDismissed
              "
              class="phone-history-balloon phone-history-balloon--danger"
              :style="phoneBalloonStyle"
            >
              <feather-icon
                icon="AlertTriangleIcon"
                size="13"
                class="mr-50 phone-history-balloon__icon"
              />
              <span class="phone-history-balloon__text">
                {{
                  phoneHistory.total > 1
                    ? $t("occurrence.phone.reportedMany", {
                        total: phoneHistory.total,
                      })
                    : $t("occurrence.phone.reportedOnce", {
                        total: phoneHistory.total,
                      })
                }}
                <template v-for="(o, idx) in phoneHistory.outcomes">
                  <strong :key="o.outcome_id"
                    >{{ o.name
                    }}{{ o.count > 1 ? " (" + o.count + "x)" : "" }}</strong
                  ><template v-if="idx < phoneHistory.outcomes.length - 1"
                    >,
                  </template>
                </template>
              </span>
              <button
                type="button"
                class="phone-history-balloon__close"
                :title="$t('occurrence.panel.close')"
                @click="phoneHistoryDismissed = true"
              >
                <feather-icon icon="XIcon" size="12" />
              </button>
            </div>
          </transition>

          <!-- Ocorrência em andamento pro mesmo telefone -->
          <transition name="phone-balloon-fade">
            <div
              v-if="duplicateOccurrence && !duplicateDismissed"
              class="duplicate-occ-card"
              :style="duplicateBalloonStyle"
            >
              <div class="duplicate-occ-card__header">
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="14"
                  class="mr-50"
                />
                <span>{{ $t("occurrence.duplicate.message") }}</span>
              </div>

              <div class="duplicate-occ-card__body">
                <div>
                  <b>{{ $t("occurrence.duplicate.protocolLabel") }}</b>
                  #{{ duplicateOccurrence.protocol }}
                </div>
                <div>
                  <b>{{ $t("occurrence.duplicate.openedAtLabel") }}</b>
                  {{ formatDateTime(duplicateOccurrence.created_at) }}
                </div>
                <div>
                  <b>{{ $t("occurrence.duplicate.requesterLabel") }}</b>
                  {{ duplicateOccurrence.requester_name }}
                </div>
                <div v-if="duplicateOccurrence.address">
                  <b>{{ $t("occurrence.duplicate.addressLabel") }}</b>
                  {{ duplicateOccurrence.address
                  }}{{
                    duplicateOccurrence.number
                      ? ", " + duplicateOccurrence.number
                      : ""
                  }}
                </div>
                <div v-if="duplicateOccurrence.dispatch_type">
                  <b>{{ $t("occurrence.duplicate.typeLabel") }}</b>
                  {{ duplicateOccurrence.dispatch_type }}
                </div>
                <div v-if="duplicateOccurrence.dispatch_reason">
                  <b>{{ $t("occurrence.duplicate.reasonLabel") }}</b>
                  {{ duplicateOccurrence.dispatch_reason }}
                </div>
                <div>
                  <b>{{ $t("occurrence.duplicate.situationLabel") }}</b>
                  <span
                    class="duplicate-occ-card__situation"
                    :class="'is-' + duplicateOccurrence.situation"
                    >{{ duplicateSituationLabel }}</span
                  >
                </div>
              </div>

              <div
                v-if="!duplicateAnnotationMode"
                class="duplicate-occ-card__actions"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-primary duplicate-occ-card__main-btn"
                  @click="duplicateDismissed = true"
                >
                  <feather-icon icon="PlusCircleIcon" size="14" class="mr-50" />
                  {{ $t("occurrence.duplicate.openNewButton") }}
                </button>
                <div class="duplicate-occ-card__secondary-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    @click="duplicateAnnotationMode = true"
                  >
                    <feather-icon icon="Edit3Icon" size="13" class="mr-50" />
                    {{ $t("occurrence.duplicate.registerNoteButton") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    :disabled="duplicateFinalizing"
                    @click="cancelDuplicateOccurrence"
                  >
                    <feather-icon icon="XCircleIcon" size="13" class="mr-50" />
                    {{ $t("occurrence.duplicate.cancelButton") }}
                  </button>
                </div>
              </div>

              <div v-else class="duplicate-occ-card__annotation">
                <textarea
                  v-model="duplicateAnnotationText"
                  class="form-control"
                  rows="2"
                  :placeholder="$t('occurrence.duplicate.notePlaceholder')"
                />
                <div class="duplicate-occ-card__actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary duplicate-occ-card__main-btn"
                    :disabled="duplicateFinalizing"
                    @click="submitDuplicateAnnotation"
                  >
                    <feather-icon icon="CheckIcon" size="14" class="mr-50" />
                    {{ $t("occurrence.duplicate.noteSubmitButton") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link duplicate-occ-card__link-btn"
                    @click="duplicateAnnotationMode = false"
                  >
                    {{ $t("common.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="form-group">
          <label
            ><span class="required">*</span>
            {{ $t("occurrence.panel.requesterNameLabel") }}</label
          >
          <input
            v-model="form.requester_name"
            type="text"
            :class="['form-control', errors.requester_name ? 'is-invalid' : '']"
            :placeholder="$t('occurrence.panel.requesterNamePlaceholder')"
          />
        </div>

        <div class="form-group">
          <label
            ><span class="required">*</span>
            {{ $t("occurrence.panel.addressLabel") }}</label
          >
          <GmapAutocomplete
            ref="autocomplete"
            :class="['form-control', errors.address ? 'is-invalid' : '']"
            :placeholder="$t('occurrence.panel.addressPlaceholder')"
            @place_changed="onPlaceChanged"
          />
        </div>

        <div class="form-group">
          <label>{{ $t("occurrence.panel.referencePointLabel") }}</label>
          <input
            v-model="form.reference_point"
            type="text"
            class="form-control"
            :placeholder="$t('occurrence.panel.referencePointPlaceholder')"
          />
        </div>

        <div class="form-group">
          <div class="d-flex justify-content-between align-items-center mb-50">
            <label class="mb-0"
              ><span class="required">*</span>
              {{ $t("occurrence.panel.complaintLabel") }}</label
            >
          </div>
          <textarea
            v-model="form.complaint"
            :class="['form-control', errors.complaint ? 'is-invalid' : '']"
            rows="3"
            :placeholder="$t('occurrence.panel.complaintPlaceholder')"
          />
          <button
            type="button"
            class="btn btn-sm btn-outline-primary btn-block py-25 mt-50"
            :disabled="
              !form.complaint.trim() ||
              improvingComplaint ||
              form.complaint === improvedComplaintSnapshot
            "
            @click="improveComplaint"
          >
            <b-spinner v-if="improvingComplaint" small class="mr-25" />
            <feather-icon v-else icon="ZapIcon" size="12" class="mr-25" />
            {{ $t("occurrence.panel.improveWithAi") }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary btn-block py-25 mt-50"
            :disabled="
              !form.complaint.trim() ||
              suggestingClassification ||
              form.complaint === suggestedClassificationSnapshot
            "
            @click="suggestClassification"
          >
            <b-spinner v-if="suggestingClassification" small class="mr-25" />
            <feather-icon v-else icon="TargetIcon" size="12" class="mr-25" />
            {{ $t("occurrence.panel.suggestClassificationWithAi") }}
          </button>
        </div>

        <div class="form-group">
          <label
            ><span class="required">*</span>
            {{ $t("occurrence.panel.disciplineLabel") }}</label
          >
          <div :class="errors.discipline_id ? 'is-invalid-vselect' : ''">
            <v-select
              v-model="form.discipline_id"
              :options="disciplines"
              :reduce="(d) => d.id"
              label="name"
              :placeholder="$t('occurrence.panel.disciplinePlaceholder')"
              class="vselect"
              @input="onDisciplineChange"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            ><span class="required">*</span>
            {{ $t("occurrence.panel.typeLabel") }}</label
          >
          <div :class="errors.dispatch_type_id ? 'is-invalid-vselect' : ''">
            <v-select
              v-model="form.dispatch_type_id"
              :options="dispatchTypes"
              :reduce="(d) => d.id"
              label="name"
              :placeholder="$t('occurrence.panel.typePlaceholder')"
              class="vselect"
              :disabled="!form.discipline_id"
              @input="onTypeChange"
            />
          </div>
        </div>

        <div v-if="showMotivo" class="form-group">
          <label>{{ $t("occurrence.panel.reasonLabel") }}</label>
          <v-select
            ref="reasonSelect"
            v-model="form.dispatch_reason_id"
            :options="dispatchReasons"
            :reduce="(d) => d.id"
            label="name"
            :placeholder="$t('occurrence.panel.reasonPlaceholder')"
            class="vselect"
            :disabled="!form.dispatch_type_id"
            @input="onReasonChange"
          />
        </div>

        <!-- Resumo da resposta de envolvidos -->
        <div v-if="victimsAnswered" class="interr-done-row mb-2">
          <span class="interr-done-label">
            <feather-icon icon="CheckCircleIcon" size="14" class="mr-25" />
            {{ victimsSummaryText }}
          </span>
          <button
            type="button"
            class="interr-done-btn"
            @click="showVictimsModal = true"
          >
            <feather-icon icon="EyeIcon" size="13" class="mr-25" />
            {{ $t("occurrence.panel.review") }}
          </button>
        </div>

        <!-- Botão: responder interrogatório pendente -->
        <div
          v-if="pendingInterrogatory && interrReviewAnswers.length === 0"
          class="mb-2"
        >
          <button
            type="button"
            :class="[
              'btn btn-block',
              pendingInterrogatoryRequired
                ? 'btn-danger'
                : 'btn-outline-secondary',
            ]"
            @click="showInterrogatoryModal = true"
          >
            <feather-icon icon="ClipboardIcon" size="14" class="mr-50" />
            {{
              pendingInterrogatoryRequired
                ? $t("occurrence.panel.respondInterrogatoryRequired")
                : $t("occurrence.panel.respondInterrogatoryOptional")
            }}
          </button>
        </div>

        <!-- Alerta: interrogatório respondido -->
        <div v-if="interrReviewAnswers.length > 0" class="interr-done-row mb-2">
          <span class="interr-done-label">
            <feather-icon icon="CheckCircleIcon" size="14" class="mr-25" />
            {{ $t("occurrence.panel.interrogatoryAnswered") }}
          </span>
          <button
            type="button"
            class="interr-done-btn"
            @click="openInterrReview"
          >
            <feather-icon icon="EyeIcon" size="13" class="mr-25" />
            {{ $t("occurrence.panel.review") }}
          </button>
        </div>
      </div>

      <div class="occ-panel__footer">
        <div
          v-if="currentOccurrenceId && $hasAbility('ocorrencia.finalizar')"
          class="mb-1"
        >
          <button
            type="button"
            class="btn btn-outline-danger btn-block"
            @click="showFinalizeModal = true"
          >
            <feather-icon icon="CheckCircleIcon" size="14" class="mr-25" />
            {{ $t("occurrence.panel.finalizeOccurrence") }}
          </button>
        </div>

        <div v-if="$hasAbility('ocorrencia.criar')" class="text-right">
          <button class="btn btn-primary btn-block" @click="save">
            <feather-icon icon="SendIcon" size="14" class="mr-25" />
            {{ $t("occurrence.panel.forwardOccurrence") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Botão flutuante centralizado no mapa -->
    <button
      v-if="$hasAbility('ocorrencia.ver')"
      class="occ-list-fab"
      @click="showListModal = true"
    >
      <i class="fa fa-list mr-1" /> {{ $t("occurrence.panel.viewOccurrences") }}
    </button>

    <!-- Modal de pergunta de envolvidos -->
    <VictimsQuestionModal
      :visible.sync="showVictimsModal"
      :discipline-id="form.discipline_id"
      :answered="victimsAnswered"
      @confirm="onVictimsConfirm"
    />

    <!-- Modal de Finalização -->
    <FinalizeOccurrenceModal
      :visible.sync="showFinalizeModal"
      :occurrence-id="currentOccurrenceId"
      :discipline-id="form.discipline_id"
      @finalized="onFinalized"
      @open-pendency="openPendency"
    />

    <BusinessRulePendenciesModal
      :payload="rulePendencies"
      :retrying="ruleRetrying"
      :title="$t('occurrence.pendencies.cannotForwardTitle')"
      @retry="executeGuarded"
      @close="closeRulePendencies"
      @open="openPendency"
    />

    <!-- Modal de Interrogatório -->
    <InterrogatoryModal
      v-if="pendingInterrogatory"
      :interrogatory="pendingInterrogatory"
      :visible.sync="showInterrogatoryModal"
      :review-answers="interrReviewAnswers"
      :mandatory="pendingInterrogatoryRequired"
      @confirm="onInterrConfirm"
      @skip="onInterrSkip"
      @close="onInterrogatoryClosed()"
    />

    <OccurrenceDetailModal
      :visible.sync="showDetailModal"
      :occurrence-id="detailOccurrenceId"
      @open-operational="irParaOperacional"
    />

    <!-- Modal de Ponto de Interesse -->
    <b-modal
      v-model="showPoiModal"
      :title="selectedPoi ? selectedPoi.name : ''"
      size="md"
      ok-only
      :ok-title="$t('occurrence.panel.close')"
      @shown="initPoiVideo"
      @hidden="onPoiModalHidden"
    >
      <div v-if="selectedPoi">
        <div class="text-muted mb-2" style="font-size: 13px">
          <feather-icon icon="TagIcon" size="12" class="mr-25" />
          {{ selectedPoi.type ? selectedPoi.type.name : "" }}
        </div>

        <video
          v-if="isCameraPoi(selectedPoi) && poiStreamUrl(selectedPoi)"
          ref="poiVideo"
          class="poi-video mb-2"
          controls
          autoplay
          muted
          playsinline
        />
        <div
          v-else-if="isCameraPoi(selectedPoi)"
          class="poi-camera-placeholder mb-2"
        >
          <feather-icon icon="VideoIcon" size="28" />
          <span>{{ $t("occurrence.mapMenu.poiModal.streamPending") }}</span>
        </div>

        <table v-if="poiTableFields(selectedPoi).length" class="w-100">
          <tr v-for="field in poiTableFields(selectedPoi)" :key="field.key">
            <th class="pb-50 pr-1 text-nowrap align-top">{{ field.label }}</th>
            <td class="pb-50">{{ field.value || "—" }}</td>
          </tr>
        </table>
      </div>
    </b-modal>

    <!-- Modal de Listagem -->
    <b-modal
      v-model="showListModal"
      :title="$t('occurrence.list.title')"
      size="xl"
      scrollable
      ok-only
      :ok-title="$t('occurrence.panel.close')"
      @show="onListModalShow"
    >
      <div class="d-flex flex-wrap align-items-end mb-1" style="gap: 10px">
        <div style="min-width: 150px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.statusLabel")
          }}</label>
          <select v-model="filters.status" class="form-control form-control-sm">
            <option value="">{{ $t("occurrence.list.statusAll") }}</option>
            <option value="1">{{ $t("occurrence.list.statusOpen") }}</option>
            <option value="2">
              {{ $t("occurrence.list.statusFinalized") }}
            </option>
            <option value="0">{{ $t("occurrence.list.statusDraft") }}</option>
          </select>
        </div>
        <div style="min-width: 150px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.protocolLabel")
          }}</label>
          <input
            v-model="filters.protocol"
            type="text"
            class="form-control form-control-sm"
            placeholder="2609050001"
            @keyup.enter="fetchOccurrences"
          />
        </div>
        <div style="min-width: 170px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.disciplineLabel")
          }}</label>
          <v-select
            v-model="filters.discipline_id"
            :options="disciplines"
            :reduce="(d) => d.id"
            label="name"
            :placeholder="$t('occurrence.list.disciplineAll')"
            class="vselect vselect--sm"
          />
        </div>
        <div style="min-width: 170px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.typeLabel")
          }}</label>
          <v-select
            v-model="filters.dispatch_type_id"
            :options="dispatchTypes"
            :reduce="(d) => d.id"
            label="name"
            :placeholder="$t('occurrence.list.typeAll')"
            class="vselect vselect--sm"
          />
        </div>
        <div style="min-width: 130px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.dateFromLabel")
          }}</label>
          <input
            v-model="filters.date_from"
            type="date"
            class="form-control form-control-sm"
          />
        </div>
        <div style="min-width: 130px">
          <label class="d-block mb-25" style="font-size: 12px">{{
            $t("occurrence.list.dateToLabel")
          }}</label>
          <input
            v-model="filters.date_to"
            type="date"
            class="form-control form-control-sm"
          />
        </div>
        <button class="btn btn-sm btn-primary" @click="fetchOccurrences">
          <i class="fa fa-search" /> {{ $t("common.search") }}
        </button>
        <button class="btn btn-sm btn-outline-secondary" @click="limparFiltros">
          {{ $t("occurrence.list.clearButton") }}
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-50">
        <small class="text-muted">
          {{ $t("occurrence.list.totalCount", { total: pagination.total }) }}
        </small>
        <button class="btn btn-sm btn-link p-0" @click="alternarOrdem">
          {{
            listSort === "desc"
              ? $t("occurrence.list.sortNewestFirst")
              : $t("occurrence.list.sortOldestFirst")
          }}
          <i
            :class="listSort === 'desc' ? 'fa fa-arrow-down' : 'fa fa-arrow-up'"
          />
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-hover occ-list">
          <thead>
            <tr>
              <th>{{ $t("occurrence.list.table.protocol") }}</th>
              <th>{{ $t("occurrence.list.disciplineLabel") }}</th>
              <th>{{ $t("occurrence.list.table.requester") }}</th>
              <th>{{ $t("occurrence.list.table.address") }}</th>
              <th>{{ $t("occurrence.list.table.typeReason") }}</th>
              <th>{{ $t("occurrence.list.table.status") }}</th>
              <th>{{ $t("occurrence.list.table.openedAt") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="occurrences.length === 0">
              <td colspan="7" class="text-center text-muted py-3">
                {{ $t("occurrence.list.table.noneFound") }}
              </td>
            </tr>
            <template v-for="item in linhasAgrupadas">
              <tr
                v-if="item.tipo === 'dia'"
                :key="item.chave"
                class="occ-list__day"
              >
                <td colspan="7">
                  {{ item.rotulo }}
                </td>
              </tr>
              <tr
                v-else
                :key="item.chave"
                class="occ-list__row--clickable"
                @click="verOcorrencia(item.occ)"
              >
                <td>
                  <span
                    class="badge badge-secondary text-monospace"
                    style="font-size: 0.82em; letter-spacing: 0.5px"
                    >{{ item.occ.protocol || "#" + item.occ.id }}</span
                  >
                </td>
                <td>
                  {{ item.occ.discipline ? item.occ.discipline.name : "—" }}
                </td>
                <td>{{ item.occ.requester_name || "—" }}</td>
                <td>{{ item.occ.address || "—" }}</td>
                <td>
                  <div>
                    {{
                      item.occ.dispatch_type ? item.occ.dispatch_type.name : "—"
                    }}
                  </div>
                  <small class="text-muted">
                    {{
                      item.occ.dispatch_reason
                        ? item.occ.dispatch_reason.name
                        : $t("occurrence.list.table.noReason")
                    }}
                    <template v-if="item.occ.discipline">
                      · {{ item.occ.discipline.name }}
                    </template>
                  </small>
                </td>
                <td>
                  <span :class="situacao(item.occ).classe">{{
                    situacao(item.occ).rotulo
                  }}</span>
                </td>
                <td style="white-space: nowrap">
                  <div>{{ horaCurta(item.occ.created_at) }}</div>
                  <small :class="duracao(item.occ).classe">{{
                    duracao(item.occ).texto
                  }}</small>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div
        v-if="pagination.last_page > 1"
        class="d-flex justify-content-end mt-2"
      >
        <pagination
          :options="opcoesPaginacao"
          v-model="pagination.current_page"
          :records="pagination.total"
          :per-page="pagination.per_page"
          @paginate="fetchOccurrences"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import swal from "sweetalert";
import vSelect from "vue-select";
import { BModal } from "bootstrap-vue";
import Pagination from "vue-pagination-2";
import opcoesPaginacao from "@/libs/paginationOptions";
import InterrogatoryModal from "@/components/InterrogatoryModal.vue";
import VictimsQuestionModal from "@/components/VictimsQuestionModal.vue";
import FinalizeOccurrenceModal from "@/components/FinalizeOccurrenceModal.vue";
import BusinessRuleGuardMixin from "@/mixins/BusinessRuleGuardMixin";
import BusinessRulePendenciesModal from "@/components/BusinessRulePendenciesModal.vue";
import OccurrenceDetailModal from "@/components/OccurrenceDetailModal.vue";
import ElapsedTimeMixin from "@/mixins/ElapsedTimeMixin";
import ApiErrorMixin from "@/mixins/ApiErrorMixin";
import OccurrenceFeedMixin from "@/mixins/OccurrenceFeedMixin";
import RealtimeResyncMixin from "@/mixins/RealtimeResyncMixin";
import Hls from "hls.js";

const PIN_PADRAO = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
const PIN_PROXIMO = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
const PIN_POI_PADRAO = "https://maps.google.com/mapfiles/ms/icons/purple-dot.png";

export default {
  name: "OccurrenceIndex",
  components: {
    vSelect,
    BModal,
    Pagination,
    InterrogatoryModal,
    VictimsQuestionModal,
    FinalizeOccurrenceModal,
    BusinessRulePendenciesModal,
    OccurrenceDetailModal,
  },

  filters: {
    date(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
  },
  mixins: [
    ElapsedTimeMixin,
    ApiErrorMixin,
    BusinessRuleGuardMixin,
    OccurrenceFeedMixin,
    RealtimeResyncMixin,
  ],

  data() {
    return {
      form: {
        requester_name: "",
        requester_phone: "",
        address: "",
        reference_point: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
        complement: "",
        zip_code: "",
        latitude: null,
        longitude: null,
        dispatch_type_id: null,
        dispatch_reason_id: null,
        discipline_id: null,
        complaint: "",
        victims_count: null,
        victims_status: null,
      },
      improvingComplaint: false,
      improvedComplaintSnapshot: "",
      suggestingClassification: false,
      suggestedClassificationSnapshot: "",
      suggestedDispatchReasonId: null,
      mapCenter: { lat: -15.77972, lng: -47.92972 },
      mapOccurrences: [],
      mapMenuOpen: false,
      labelMenuOpen: false,
      mapLabelField: null,
      showPois: false,
      pois: [],
      poisLoaded: false,
      selectedPoi: null,
      showPoiModal: false,
      hls: null,
      // Ids das ocorrências apontadas como próximas no último alerta de
      // proximidade — usado só pra pintar o pin de verde no mapa.
      nearbyOccurrenceIds: [],
      // Histórico de desfechos desse telefone (trote etc.) — balão flutuante abaixo do campo.
      phoneHistory: null,
      phoneHistoryDismissed: false,
      // position:fixed calculado na mão (getBoundingClientRect do input) —
      // o painel lateral tem overflow-y:auto, e um balão position:absolute
      // ficava cortado/rolando junto em vez de sobrepor o mapa ao lado.
      phoneBalloonStyle: {},
      // Ocorrência ainda aberta (não finalizada) pro mesmo telefone —
      // card com "Abrir nova"/"Registrar anotação"/"Cancelar".
      duplicateOccurrence: null,
      duplicateDismissed: false,
      duplicateAnnotationMode: false,
      duplicateAnnotationText: "",
      duplicateFinalizing: false,
      duplicateBalloonStyle: {},
      quickOutcomeIds: { information: null, cancelled: null },
      markerIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: { width: 48, height: 48 },
        anchor: { x: 24, y: 48 },
      },
      showInfoWindow: false,
      infoWindowPos: null,
      selectedMapOcc: null,
      dispatchTypes: [],
      dispatchReasons: [],
      disciplines: [],
      showListModal: false,
      pinsVerificados: [],
      pinsQuebrados: [],
      showDetailModal: false,
      detailOccurrenceId: null,
      occurrences: [],
      filters: {
        discipline_id: null,
        dispatch_type_id: null,
        date_from: "",
        date_to: "",
        status: "1",
        protocol: "",
      },
      listSort: "desc",
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
      },
      pendingInterrogatory: null,
      pendingInterrogatoryRequired: false,
      showInterrogatoryModal: false,
      pendingInterrAnswers: null,
      interrReviewAnswers: [],
      pendingInvolveds: [],
      showVictimsModal: false,
      victimsAnswered: false,
      victimsAnswer: null,
      showMotivo: false,
      currentOccurrenceId: null,
      currentProtocol: "",
      creatingOccurrence: false,
      phoneCreateError: false,
      showFinalizeModal: false,
      currentOccurrenceCreatedAt: null,
      errors: {},
    };
  },

  computed: {
    opcoesPaginacao() {
      return opcoesPaginacao;
    },

    visiblePois() {
      return this.showPois ? this.pois : [];
    },

    mapLabelOptions() {
      return [
        { field: "protocol", label: this.$t("occurrence.mapMenu.protocol") },
        {
          field: "requester_name",
          label: this.$t("occurrence.mapMenu.requesterName"),
        },
        { field: "dispatch_type", label: this.$t("occurrence.mapMenu.type") },
      ];
    },

    duplicateSituationLabel() {
      if (!this.duplicateOccurrence) return "";
      const key = {
        aberta: "occurrence.duplicate.situationOpen",
        aguardando_despacho: "occurrence.duplicate.situationAwaitingDispatch",
        despachado: "occurrence.duplicate.situationDispatched",
      }[this.duplicateOccurrence.situation];
      return key ? this.$t(key) : this.duplicateOccurrence.situation;
    },

    linhasAgrupadas() {
      const saida = [];
      let diaAtual = null;

      this.occurrences.forEach((occ) => {
        const dia = (occ.created_at || "").slice(0, 10);

        if (dia !== diaAtual) {
          diaAtual = dia;
          saida.push({
            tipo: "dia",
            chave: `dia-${dia}`,
            rotulo: this.diaLongo(occ.created_at),
          });
        }

        saida.push({ tipo: "linha", chave: `occ-${occ.id}`, occ });
      });

      return saida;
    },

    victimsSummaryText() {
      if (!this.victimsAnswer) return "";
      const { status, count } = this.victimsAnswer;
      if (status === "informed" && count === 1)
        return this.$t("occurrence.victims.oneInvolved");
      if (status === "informed")
        return this.$t("occurrence.victims.countInvolved", { count });
      if (status === "none") return this.$t("occurrence.victims.none");
      return this.$t("occurrence.victims.unknown");
    },
  },

  mounted() {
    document.documentElement.style.overflow = "hidden";
    this.loadInitialData();
    this.checkDraft();
    this.loadMapLabelFieldFromStorage();
    this.loadPoisVisibilityFromStorage();
    this.loadQuickOutcomes();

    this.watchOccurrenceFeed();
    this.watchRealtimeResync(() => this.loadMapData(false));

    window.addEventListener("resize", this.positionPhoneBalloon);
    document.addEventListener("click", this.handleMapMenuDocClick);
  },

  beforeDestroy() {
    document.documentElement.style.overflow = "";
    this.unwatchOccurrenceFeed();
    window.removeEventListener("resize", this.positionPhoneBalloon);
    document.removeEventListener("click", this.handleMapMenuDocClick);
  },

  methods: {
    loadInitialData() {
      const self = this;
      const { api } = self.$store.state;
      const selectedNode = self.$store.state.selected_node;

      // Só as disciplinas ativas no nó do operador (configuradas em
      // Node/DisciplineConfig) — antes vinha a lista inteira, ignorando o
      // que foi ativado por nó.
      axios
        .get(`${api}discipline/for-node`, {
          params: { node_id: selectedNode?.id },
        })
        .then((r) => (self.disciplines = r.data.data))
        .catch(() => {});

      // Pins do mapa
      self.loadMapData();
    },

    getMarkerIcon(occ) {
      // Pin de ocorrência apontada como próxima no último alerta de
      // proximidade fica verde, sobrepondo o pin de tipo/disciplina — é pra
      // chamar atenção mesmo, não pra manter a identidade visual normal.
      if (occ && this.nearbyOccurrenceIds.includes(occ.id)) {
        return {
          url: PIN_PROXIMO,
          scaledSize: { width: 48, height: 48 },
          anchor: { x: 24, y: 48 },
          labelOrigin: { x: 24, y: -14 },
        };
      }

      const url =
        this.pinUtilizavel(occ && occ.dispatch_type_pin_url) ||
        this.pinUtilizavel(occ && occ.discipline_pin_url) ||
        PIN_PADRAO;

      return {
        url,
        scaledSize: { width: 48, height: 48 },
        anchor: { x: 24, y: 48 },
        labelOrigin: { x: 24, y: -14 },
      };
    },

    getMarkerLabel(occ) {
      if (!this.mapLabelField) return null;

      const text = occ && occ[this.mapLabelField];
      if (!text) return null;

      return {
        text: String(text),
        className: "occ-map-pin-label",
        color: "#1a3c73",
        fontSize: "12px",
        fontWeight: "700",
      };
    },

    toggleMapMenu() {
      this.mapMenuOpen = !this.mapMenuOpen;
      if (!this.mapMenuOpen) this.labelMenuOpen = false;
    },

    closeMapMenu() {
      this.mapMenuOpen = false;
      this.labelMenuOpen = false;
    },

    handleMapMenuDocClick(event) {
      if (!this.mapMenuOpen) return;
      const menu = this.$refs.mapMenu;
      if (menu && !menu.contains(event.target)) this.closeMapMenu();
    },

    setMapLabelField(field) {
      this.mapLabelField = field;
      this.closeMapMenu();

      try {
        if (field) {
          localStorage.setItem("occurrenceMapLabelField", field);
        } else {
          localStorage.removeItem("occurrenceMapLabelField");
        }
      } catch (e) {}
    },

    loadMapLabelFieldFromStorage() {
      try {
        const saved = localStorage.getItem("occurrenceMapLabelField");
        const known = this.mapLabelOptions.some((o) => o.field === saved);
        if (saved && known) this.mapLabelField = saved;
      } catch (e) {}
    },

    togglePois() {
      this.showPois = !this.showPois;
      this.closeMapMenu();

      try {
        localStorage.setItem("occurrenceMapShowPois", this.showPois ? "1" : "0");
      } catch (e) {}

      if (this.showPois && !this.poisLoaded) this.loadPois();
    },

    loadPoisVisibilityFromStorage() {
      try {
        const saved = localStorage.getItem("occurrenceMapShowPois");
        if (saved === "1") {
          this.showPois = true;
          this.loadPois();
        }
      } catch (e) {}
    },

    loadPois() {
      const self = this;
      axios
        .get(`${self.$store.state.api}pois`, {
          params: { with: ["type"], paginated: false, status: 1 },
        })
        .then((response) => {
          self.pois = response.data.data;
          self.poisLoaded = true;
        })
        .catch(() => {});
    },

    getPoiMarkerIcon(poi) {
      const customUrl = this.pinUtilizavel(poi && poi.type && poi.type.pin_icon);

      // Pins customizados (upload) são balões 100x140 (proporção ~5:7); o pin
      // padrão do Google é um dot quadrado — cada um precisa de um tamanho
      // diferente pra não esmagar/deformar a imagem.
      if (customUrl) {
        return {
          url: customUrl,
          scaledSize: { width: 34, height: 48 },
          anchor: { x: 17, y: 48 },
        };
      }

      return {
        url: PIN_POI_PADRAO,
        scaledSize: { width: 32, height: 32 },
        anchor: { x: 16, y: 32 },
      };
    },

    openPoiModal(poi) {
      this.selectedPoi = poi;
      this.showPoiModal = true;
    },

    isCameraPoi(poi) {
      const fields = (poi && poi.type && poi.type.field_schema) || [];
      return fields.some((f) => /rtsp/i.test(f.key));
    },

    // O campo é salvo com key "rtsp_url" mas o valor pode ser tanto um rtsp://
    // cru (não toca no navegador) quanto uma URL HLS (.m3u8) já pronta pra
    // reproduzir. Só a segunda forma toca de fato; a primeira cai no placeholder.
    poiStreamUrl(poi) {
      const fields = (poi && poi.type && poi.type.field_schema) || [];
      const metadata = (poi && poi.metadata) || {};
      const field = fields.find((f) => /rtsp/i.test(f.key));
      const value = field && metadata[field.key];

      if (!value || !/\.m3u8(\?|$)/i.test(value)) return null;

      return value;
    },

    initPoiVideo() {
      const url = this.poiStreamUrl(this.selectedPoi);
      const video = this.$refs.poiVideo;
      if (!url || !video) return;

      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(url);
        this.hls.attachMedia(video);
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = url;
      }
    },

    destroyPoiVideo() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },

    onPoiModalHidden() {
      this.destroyPoiVideo();
      this.selectedPoi = null;
    },

    poiMetadataFields(poi) {
      const fields = (poi && poi.type && poi.type.field_schema) || [];
      const metadata = (poi && poi.metadata) || {};

      return fields.map((f) => ({
        key: f.key,
        label: f.label || f.key,
        value: metadata[f.key],
      }));
    },

    // Some do campo do stream quando o vídeo já está sendo exibido pelo
    // player — mostrar a URL crua junto ficaria redundante.
    poiTableFields(poi) {
      if (!this.poiStreamUrl(poi)) return this.poiMetadataFields(poi);

      return this.poiMetadataFields(poi).filter((f) => !/rtsp/i.test(f.key));
    },

    // Centraliza o mapa pra enquadrar todas as ocorrências visíveis —
    // diferente do recentrar automático do loadMapData, que só olha pro
    // primeiro pin (útil ao carregar, mas não serve pra "me mostra tudo").
    fitAllOccurrences() {
      this.closeMapMenu();

      if (!this.$refs.mapRef || !this.mapOccurrences.length) return;

      this.$refs.mapRef.$mapPromise.then((map) => {
        if (!window.google || !window.google.maps) return;

        const bounds = new window.google.maps.LatLngBounds();
        this.mapOccurrences.forEach((occ) => {
          if (occ.latitude && occ.longitude) {
            bounds.extend(
              new window.google.maps.LatLng(occ.latitude, occ.longitude)
            );
          }
        });

        if (bounds.isEmpty()) return;

        map.fitBounds(bounds, { top: 60, right: 60, bottom: 60, left: 60 });

        window.google.maps.event.addListenerOnce(map, "idle", () => {
          if (map.getZoom() > 16) map.setZoom(16);
        });
      });
    },

    // Ícone que não carrega faz o Google Maps não desenhar marcador nenhum —
    // a ocorrência some do mapa sem erro. Aqui uma URL que falhou é
    // descartada e o pin padrão assume.
    pinUtilizavel(url) {
      if (!url || this.pinsQuebrados.includes(url)) return null;

      this.verificarPin(url);

      return url;
    },

    verificarPin(url) {
      if (this.pinsVerificados.includes(url)) return;

      this.pinsVerificados.push(url);

      const img = new Image();
      img.onerror = () => {
        if (!this.pinsQuebrados.includes(url)) this.pinsQuebrados.push(url);
      };
      img.src = url;
    },

    timeAgo(dateStr) {
      if (!dateStr) return "";
      const diff = Math.floor(
        (Date.now() - new Date(dateStr).getTime()) / 1000
      );
      if (diff < 60) return this.$t("occurrence.timeAgo.now");
      if (diff < 3600) {
        const m = Math.floor(diff / 60);
        return this.$t("occurrence.timeAgo.minutes", { m });
      }
      if (diff < 86400) {
        const h = Math.floor(diff / 3600);
        return this.$t("occurrence.timeAgo.hours", { h });
      }
      const d = Math.floor(diff / 86400);
      return d > 1
        ? this.$t("occurrence.timeAgo.days", { d })
        : this.$t("occurrence.timeAgo.day", { d });
    },

    haversineKm(lat1, lng1, lat2, lng2) {
      const toRad = (v) => (v * Math.PI) / 180;
      const R = 6371; // raio da Terra em km
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    },

    // Avisa o TARM se já existe outra ocorrência aberta perto do endereço
    // digitado — evita duplicidade (duas equipes despachadas pro mesmo caso
    // sem perceber). `mapOccurrences` já traz só ocorrências abertas (status=1)
    // do nó do operador, então não precisa de outra chamada à API.
    checkNearbyOccurrences() {
      const NEARBY_RADIUS_KM = 1;
      // Sempre limpa antes de recalcular — endereço mudou, o destaque de
      // "próxima" antigo não vale mais.
      this.nearbyOccurrenceIds = [];

      const lat = parseFloat(this.form.latitude);
      const lng = parseFloat(this.form.longitude);
      if (!lat || !lng || !this.mapOccurrences || !this.mapOccurrences.length)
        return;

      const nearby = this.mapOccurrences.filter((o) => {
        if (this.currentOccurrenceId && o.id === this.currentOccurrenceId)
          return false;
        if (!o.latitude || !o.longitude) return false;
        return (
          this.haversineKm(lat, lng, o.latitude, o.longitude) <=
          NEARBY_RADIUS_KM
        );
      });

      if (!nearby.length) return;

      this.nearbyOccurrenceIds = nearby.map((o) => o.id);

      const MAX_LISTED = 5;
      const lines = nearby
        .slice(0, MAX_LISTED)
        .map((o) => {
          const proto = o.protocol || `#${o.id}`;
          const addr =
            o.address || this.$t("occurrence.nearby.addressNotProvided");
          const queixa = o.complaint
            ? `\n${this.$t("occurrence.nearby.complaintLine", {
                complaint: o.complaint,
              })}`
            : "";
          return `${proto} — ${addr} (${this.timeAgo(o.created_at)})${queixa}`;
        })
        .join("\n\n");
      const extra =
        nearby.length > MAX_LISTED
          ? `\n\n${this.$t("occurrence.nearby.andMore", {
              count: nearby.length - MAX_LISTED,
            })}`
          : "";

      const title =
        nearby.length > 1
          ? this.$t("occurrence.nearby.titlePlural", {
              count: nearby.length,
              km: NEARBY_RADIUS_KM,
            })
          : this.$t("occurrence.nearby.titleSingular", {
              count: nearby.length,
              km: NEARBY_RADIUS_KM,
            });

      swal({
        title,
        text: `${lines}${extra}\n\n${this.$t("occurrence.nearby.confirmText")}`,
        icon: "warning",
      });
    },

    applyOccurrenceFeed() {
      this.scheduleRealtimeReload(() => {
        this.clearOccurrenceFeed();
        this.loadMapData(false);
      });
    },

    loadMapData(recentrar = true) {
      const self = this;
      axios
        .get(`${self.$store.state.api}occurrences/map-data`)
        .then((r) => {
          self.mapOccurrences = r.data.data;
          // Centraliza no primeiro pin se existir. Recarga por evento nao
          // recentra: o operador pode estar olhando outro ponto do mapa.
          if (recentrar && self.mapOccurrences.length > 0) {
            self.mapCenter = {
              lat: self.mapOccurrences[0].latitude,
              lng: self.mapOccurrences[0].longitude,
            };
          }
        })
        .catch(() => {});
    },

    onDisciplineChange(disciplineId) {
      this.form.dispatch_type_id = null;
      this.form.dispatch_reason_id = null;
      this.dispatchTypes = [];
      this.dispatchReasons = [];
      if (!disciplineId) return Promise.resolve();
      return axios
        .get(`${this.$store.state.api}dispatch_types/for-node`, {
          params: {
            discipline_id: disciplineId,
            node_id: this.$store.state.selected_node?.id,
            status: 1,
          },
        })
        .then((r) => (this.dispatchTypes = r.data.data))
        .catch(() => {});
    },

    onTypeChange(typeId) {
      this.form.dispatch_reason_id = null;
      this.suggestedDispatchReasonId = null;
      this.dispatchReasons = [];
      this.pendingInterrogatory = null;
      this.pendingInterrogatoryRequired = false;
      this.pendingInterrAnswers = null;
      this.interrReviewAnswers = [];

      this.showMotivo = false;
      this.victimsAnswered = false;
      this.victimsAnswer = null;
      this.form.victims_count = null;
      this.form.victims_status = null;
      this.pendingInvolveds = [];

      if (!typeId) return;
      axios
        .get(`${this.$store.state.api}dispatch_reasons/for-node`, {
          params: {
            dispatch_type_id: typeId,
            node_id: this.$store.state.selected_node?.id,
            status: 1,
          },
        })
        .then((r) => (this.dispatchReasons = r.data.data))
        .catch(() => {});

      this.showVictimsModal = true;
    },

    onVictimsConfirm(payload) {
      this.victimsAnswer = { status: payload.status, count: payload.count };
      this.victimsAnswered = true;
      this.form.victims_status = payload.status;
      this.form.victims_count = payload.count;
      this.pendingInvolveds = payload.involveds || [];

      if (payload.status === "informed" && payload.count === 1) {
        this.showMotivo = true;
        if (
          this.suggestedDispatchReasonId &&
          this.dispatchReasons.some(
            (r) => r.id === this.suggestedDispatchReasonId
          )
        ) {
          this.form.dispatch_reason_id = this.suggestedDispatchReasonId;
          this.onReasonChange(this.suggestedDispatchReasonId);
        }
      } else {
        this.showMotivo = false;
        this.form.dispatch_reason_id = null;
      }
      // Sugestão é de uso único: some depois de aplicada (ou de constatar que
      // o Motivo nem vai aparecer nesse fluxo).
      this.suggestedDispatchReasonId = null;
    },

    onReasonChange(reasonId) {
      this.pendingInterrogatory = null;
      this.pendingInterrogatoryRequired = false;
      this.pendingInterrAnswers = null;
      this.interrReviewAnswers = [];
      if (!reasonId) return;

      const reason = this.dispatchReasons.find((r) => r.id === reasonId);
      if (reason && reason.interrogatory_id) {
        this.pendingInterrogatoryRequired = !!reason.interrogatory_required;
        axios
          .get(
            `${this.$store.state.api}interrogatories/${reason.interrogatory_id}?with[]=questions.alternatives`
          )
          .then((r) => {
            this.pendingInterrogatory = r.data.data[0];
            this.showInterrogatoryModal = true;
          })
          .catch(() => {});
      }
    },

    onPlaceChanged(place) {
      if (!place || !place.geometry) return;

      const loc = place.geometry.location;
      this.form.latitude = loc.lat();
      this.form.longitude = loc.lng();

      // Centraliza o mapa na localização
      this.mapCenter = { lat: loc.lat(), lng: loc.lng() };

      // Extrai componentes de endereço
      const components = place.address_components || [];
      const get = (type) => {
        const c = components.find((c) => c.types.includes(type));
        return c ? c.long_name : "";
      };
      const getShort = (type) => {
        const c = components.find((c) => c.types.includes(type));
        return c ? c.short_name : "";
      };

      this.form.address =
        (get("route") || "") +
        (get("street_number") ? `, ${get("street_number")}` : "");
      this.form.neighborhood =
        get("sublocality_level_1") || get("sublocality") || get("neighborhood");
      this.form.city = get("administrative_area_level_2") || get("locality");
      this.form.state = getShort("administrative_area_level_1");
      this.form.zip_code = get("postal_code");
      this.form.number = get("street_number");

      this.checkNearbyOccurrences();
    },

    // Só permite setar/ajustar o pin pelo mapa depois que telefone e
    // endereço já foram preenchidos — evita setar localização antes mesmo
    // de começar a abrir a ocorrência.
    canSetMapPin() {
      return !!(this.form.requester_phone && this.form.address);
    },

    onMapClick(event) {
      if (!this.canSetMapPin()) return;

      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.form.latitude = lat.toFixed(7);
      this.form.longitude = lng.toFixed(7);

      // Reverse geocoding
      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const place = results[0];
            const input = this.$refs.autocomplete;
            // Atualiza o campo de texto do autocomplete
            if (input && input.$refs && input.$refs.input) {
              input.$refs.input.value = place.formatted_address;
            }
            this.onPlaceChanged(place);
          }
        });
      }
    },

    onMarkerDrag(event) {
      if (!this.canSetMapPin()) return;

      this.form.latitude = event.latLng.lat().toFixed(7);
      this.form.longitude = event.latLng.lng().toFixed(7);
      this.checkNearbyOccurrences();
    },

    onInterrConfirm(payload) {
      this.pendingInterrAnswers = payload;
      this.interrReviewAnswers = payload.answers || [];
      this.showInterrogatoryModal = false;
    },

    onInterrSkip() {
      this.pendingInterrAnswers = null;
      this.interrReviewAnswers = [];
      this.pendingInterrogatory = null;
      this.pendingInterrogatoryRequired = false;
      this.showInterrogatoryModal = false;
    },

    /**
     * Roda no `close` do modal, que o InterrogatoryModal emite a partir do
     * `hidden` da BootstrapVue — depois de ela devolver o foco. E o unico
     * instante em que fechar o select resolve: antes disso o foco ainda
     * voltaria para ele, e o vue-select abre a lista em qualquer evento de
     * foco (`onSearchFocus` faz `open = true`).
     */
    onInterrogatoryClosed() {
      this.showInterrogatoryModal = false;

      const select = this.$refs.reasonSelect;
      if (!select) return;

      if (select.searchEl) select.searchEl.blur();
      if (typeof select.closeSearchOptions === "function") {
        select.closeSearchOptions();
      }
    },

    openInterrReview() {
      this.showInterrogatoryModal = true;
    },

    onPhoneBlur() {
      const phone = this.form.requester_phone.replace(/\D/g, "");

      // Independe de já existir rascunho — roda toda vez que o telefone muda.
      if (phone.length >= 10) {
        this.checkPhoneHistory();
        this.checkOpenOccurrenceByPhone();
      } else {
        this.phoneHistory = null;
        this.duplicateOccurrence = null;
      }

      if (
        phone.length < 10 ||
        this.currentOccurrenceId ||
        this.creatingOccurrence
      )
        return;
      this.phoneCreateError = false;
      this.creatingOccurrence = true;
      axios
        .post(`${this.$store.state.api}occurrences`, {
          requester_phone: this.form.requester_phone,
          status: 0,
        })
        .then((r) => {
          const occurrence = r.data.data || r.data;
          this.currentOccurrenceId = occurrence.id;
          this.currentProtocol = occurrence.protocol || "";
          this.currentOccurrenceCreatedAt = occurrence.created_at || null;
          this.loadMapData();
        })
        .catch(() => {
          this.phoneCreateError = true;
        })
        .finally(() => {
          this.creatingOccurrence = false;
        });
    },

    // Avisa o TARM se esse telefone já teve ocorrência(s) finalizada(s) com
    // desfecho marcado como trote (ou qualquer outro desfecho, pra contexto).
    checkPhoneHistory() {
      this.phoneHistoryDismissed = false;
      axios
        .get(`${this.$store.state.api}occurrences/phone-history`, {
          params: { phone: this.form.requester_phone },
        })
        .then((r) => {
          this.phoneHistory = r.data.data || null;
          this.$nextTick(this.positionPhoneBalloon);
        })
        .catch(() => {
          this.phoneHistory = null;
        });
    },

    // position:fixed em coordenadas de tela, lido do input na hora — assim o
    // balão sobrepõe o mapa ao lado em vez de forçar scroll no painel, que
    // tem overflow-y:auto e cortaria/rolaria um position:absolute normal.
    positionPhoneBalloon() {
      const input = this.$refs.phoneInput;
      if (!input) return;
      const rect = input.getBoundingClientRect();
      this.phoneBalloonStyle = {
        top: `${rect.top}px`,
        left: `${rect.right + 14}px`,
      };
    },

    onPanelScroll() {
      if (this.phoneHistory && !this.phoneHistoryDismissed) {
        this.positionPhoneBalloon();
      }
      if (this.duplicateOccurrence && !this.duplicateDismissed) {
        this.positionDuplicateBalloon();
      }
    },

    // Ocorrência ainda em andamento (não finalizada) pro mesmo telefone —
    // evita duplicidade quando o solicitante liga de novo antes do
    // atendimento anterior terminar.
    checkOpenOccurrenceByPhone() {
      this.duplicateDismissed = false;
      this.duplicateAnnotationMode = false;
      this.duplicateAnnotationText = "";
      axios
        .get(`${this.$store.state.api}occurrences/open-by-phone`, {
          params: { phone: this.form.requester_phone },
        })
        .then((r) => {
          this.duplicateOccurrence = r.data.data || null;
          this.$nextTick(this.positionDuplicateBalloon);
        })
        .catch(() => {
          this.duplicateOccurrence = null;
        });
    },

    loadQuickOutcomes() {
      axios
        .get(`${this.$store.state.api}occurrences/quick-outcomes`)
        .then((r) => {
          this.quickOutcomeIds = {
            information: r.data.information_outcome_id || null,
            cancelled: r.data.cancelled_outcome_id || null,
          };
        })
        .catch(() => {});
    },

    positionDuplicateBalloon() {
      const input = this.$refs.phoneInput;
      if (!input) return;
      const rect = input.getBoundingClientRect();
      this.duplicateBalloonStyle = {
        top: `${rect.top}px`,
        left: `${rect.right + 14}px`,
      };
    },

    finalizeDuplicateOccurrence(outcomeId, observation, successMessageKey) {
      if (!this.duplicateOccurrence || !outcomeId) return;
      this.duplicateFinalizing = true;
      axios
        .post(
          `${this.$store.state.api}occurrences/duplicate-phone-outcome`,
          {
            occurrence_id: this.duplicateOccurrence.id,
            outcome_id: outcomeId,
            outcome_observation: observation || null,
          }
        )
        .then(() => {
          this.duplicateOccurrence = null;
          this.duplicateAnnotationMode = false;
          this.duplicateAnnotationText = "";
          this.loadMapData();
          if (successMessageKey) {
            this.$message(
              this.$t("occurrence.duplicate.successTitle"),
              this.$t(successMessageKey),
              "success"
            );
          }
        })
        .catch((e) => {
          this.$message(
            this.$t("occurrence.duplicate.errorTitle"),
            (e.response && e.response.data && e.response.data.message) ||
              this.$t("occurrence.duplicate.finalizeError"),
            "error"
          );
        })
        .finally(() => {
          this.duplicateFinalizing = false;
        });
    },

    submitDuplicateAnnotation() {
      if (!this.duplicateAnnotationText.trim()) {
        this.$message(
          this.$t("occurrence.duplicate.errorTitle"),
          this.$t("occurrence.duplicate.noteRequired"),
          "warning"
        );
        return;
      }
      swal({
        title: this.$t("occurrence.duplicate.noteConfirmTitle"),
        text: this.$t("occurrence.duplicate.noteConfirmText"),
        icon: "warning",
        buttons: {
          catch: {
            text: this.$t("common.cancel"),
            value: "cancel",
            className: "btn-secondary",
          },
          confirm: {
            text: this.$t("occurrence.duplicate.noteConfirmButton"),
            value: "confirm",
            className: "btn-primary",
          },
        },
      }).then((value) => {
        if (value !== "confirm") return;
        this.finalizeDuplicateOccurrence(
          this.quickOutcomeIds.information,
          this.duplicateAnnotationText.trim(),
          "occurrence.duplicate.noteSuccess"
        );
      });
    },

    cancelDuplicateOccurrence() {
      swal({
        title: this.$t("occurrence.duplicate.cancelConfirmTitle"),
        text: this.$t("occurrence.duplicate.cancelConfirmText"),
        icon: "warning",
        buttons: {
          catch: {
            text: this.$t("common.cancel"),
            value: "cancel",
            className: "btn-secondary",
          },
          confirm: {
            text: this.$t("occurrence.duplicate.cancelConfirmButton"),
            value: "confirm",
            className: "btn-danger",
          },
        },
      }).then((value) => {
        if (value !== "confirm") return;
        this.finalizeDuplicateOccurrence(
          this.quickOutcomeIds.cancelled,
          null,
          "occurrence.duplicate.cancelSuccess"
        );
      });
    },

    retryOpenOccurrence() {
      this.phoneCreateError = false;
      this.onPhoneBlur();
    },

    // Best-effort: registra a decisão do TARM sobre uma sugestão de IA para
    // auditoria. Não bloqueia nem avisa o operador se falhar — é rastro, não
    // parte do fluxo operacional.
    recordAiDecision(logId, decision) {
      if (!logId) return;
      axios
        .post(`${this.$store.state.api}ai_suggestion_logs/${logId}/decision`, {
          decision,
        })
        .catch(() => {});
    },

    async improveComplaint() {
      if (!this.form.complaint.trim() || this.improvingComplaint) return;
      this.improvingComplaint = true;
      try {
        const r = await axios.post(
          `${this.$store.state.api}occurrences/complaint/improve`,
          {
            complaint: this.form.complaint,
            occurrence_id: this.currentOccurrenceId,
          }
        );
        const { complaint: suggested, log_id: logId } = r.data.data;

        const h = this.$createElement;
        const message = h("div", [
          h(
            "p",
            { class: "mb-50" },
            this.$t("occurrence.messages.aiRewriteSuggestion")
          ),
          h(
            "p",
            { class: "font-weight-bold border rounded p-1 mb-50" },
            suggested
          ),
          h(
            "small",
            { class: "text-muted" },
            this.$t("occurrence.messages.reviewBeforeUsing")
          ),
        ]);
        const confirmed = await this.$bvModal.msgBoxConfirm([message], {
          title: this.$t("occurrence.messages.aiSuggestionTitle"),
          okTitle: this.$t("occurrence.messages.useSuggestion"),
          cancelTitle: this.$t("occurrence.messages.keepOriginal"),
          okVariant: "primary",
          centered: true,
        });

        this.recordAiDecision(logId, confirmed ? "accepted" : "rejected");
        if (confirmed) {
          this.form.complaint = suggested;
          this.improvedComplaintSnapshot = suggested;
        }
      } catch (e) {
        this.$message(
          this.$t("occurrence.messages.errorTitle"),
          this.apiErrorText(
            e,
            this.$t("occurrence.messages.improveComplaintFailed")
          ),
          "error"
        );
      } finally {
        this.improvingComplaint = false;
      }
    },

    async suggestClassification() {
      if (!this.form.complaint.trim() || this.suggestingClassification) return;
      this.suggestingClassification = true;
      try {
        const r = await axios.post(
          `${this.$store.state.api}occurrences/complaint/suggest-classification`,
          {
            complaint: this.form.complaint,
            occurrence_id: this.currentOccurrenceId,
          }
        );
        const {
          discipline_id,
          discipline_name,
          dispatch_type_id,
          dispatch_type_name,
          dispatch_reason_id,
          dispatch_reason_name,
          log_id: logId,
        } = r.data.data;
        this.suggestedClassificationSnapshot = this.form.complaint;

        if (!discipline_id) {
          this.$message(
            this.$t("occurrence.messages.aiTitle"),
            this.$t("occurrence.messages.classificationLowConfidence"),
            "info"
          );
          return;
        }

        const h = this.$createElement;
        const rows = [
          h("li", [
            h("strong", this.$t("occurrence.fields.disciplineColon")),
            discipline_name,
          ]),
          h("li", [
            h("strong", this.$t("occurrence.fields.typeColon")),
            dispatch_type_name,
          ]),
        ];
        if (dispatch_reason_name) {
          rows.push(
            h("li", [
              h("strong", this.$t("occurrence.fields.reasonColon")),
              dispatch_reason_name,
            ])
          );
        }
        const message = h("div", [
          h(
            "p",
            { class: "mb-50" },
            this.$t("occurrence.messages.aiClassificationSuggestion")
          ),
          h("ul", { class: "pl-1 mb-50" }, rows),
          h(
            "small",
            { class: "text-muted" },
            this.$t("occurrence.messages.reviewBeforeApplying")
          ),
        ]);
        const confirmed = await this.$bvModal.msgBoxConfirm([message], {
          title: this.$t("occurrence.messages.aiClassificationSuggestionTitle"),
          okTitle: this.$t("occurrence.messages.applySuggestion"),
          cancelTitle: this.$t("occurrence.messages.ignore"),
          okVariant: "primary",
          centered: true,
        });

        this.recordAiDecision(logId, confirmed ? "accepted" : "rejected");
        if (!confirmed) return;

        this.form.discipline_id = discipline_id;
        await Promise.resolve(this.onDisciplineChange(discipline_id));
        if (
          dispatch_type_id &&
          this.dispatchTypes.some((t) => t.id === dispatch_type_id)
        ) {
          this.form.dispatch_type_id = dispatch_type_id;
          this.onTypeChange(dispatch_type_id);
          // "Motivo" só aparece depois que o operador confirmar o modal de
          // vítimas — guardamos a sugestão e aplicamos em onVictimsConfirm,
          // quando o campo realmente existir na tela.
          this.suggestedDispatchReasonId = dispatch_reason_id || null;
        }
      } catch (e) {
        this.$message(
          this.$t("occurrence.messages.errorTitle"),
          this.apiErrorText(
            e,
            this.$t("occurrence.messages.suggestClassificationFailed")
          ),
          "error"
        );
      } finally {
        this.suggestingClassification = false;
      }
    },

    checkDraft() {
      axios
        .get(`${this.$store.state.api}occurrences/my-draft`)
        .then((r) => {
          const occ = r.data.data;
          if (!occ) return;
          this.currentOccurrenceId = occ.id;
          this.currentProtocol = occ.protocol || "";
          this.currentOccurrenceCreatedAt = occ.created_at || null;
          const fields = [
            "requester_phone",
            "requester_name",
            "address",
            "reference_point",
            "number",
            "neighborhood",
            "city",
            "state",
            "complement",
            "zip_code",
            "latitude",
            "longitude",
            "dispatch_type_id",
            "dispatch_reason_id",
            "discipline_id",
            "complaint",
            "victims_count",
            "victims_status",
          ];
          fields.forEach((f) => {
            if (occ[f] !== null && occ[f] !== undefined) this.form[f] = occ[f];
          });
          if (this.form.requester_phone) this.checkPhoneHistory();
          if (occ.victims_status) {
            this.victimsAnswered = true;
            this.victimsAnswer = {
              status: occ.victims_status,
              count: occ.victims_count,
            };
            this.showMotivo =
              occ.victims_status === "informed" && occ.victims_count === 1;
          }
          const { api } = this.$store.state;
          const nodeId = this.$store.state.selected_node?.id;
          if (occ.discipline_id) {
            axios
              .get(`${api}dispatch_types/for-node`, {
                params: {
                  discipline_id: occ.discipline_id,
                  node_id: nodeId,
                  status: 1,
                },
              })
              .then((r) => {
                this.dispatchTypes = r.data.data;
              });
          }
          if (occ.dispatch_type_id) {
            axios
              .get(`${api}dispatch_reasons/for-node`, {
                params: {
                  dispatch_type_id: occ.dispatch_type_id,
                  node_id: nodeId,
                  status: 1,
                },
              })
              .then((r) => {
                this.dispatchReasons = r.data.data;
              });
          }
          this.$nextTick(() => {
            if (this.$refs.autocomplete?.$refs?.input) {
              this.$refs.autocomplete.$refs.input.value = occ.address || "";
            }
          });
        })
        .catch(() => {});
    },

    openPendency(violation) {
      this.closeRulePendencies();
      this.showFinalizeModal = false;

      this.$router.push({
        name: "regulacao-detail",
        params: { id: this.currentOccurrenceId },
        query: {
          involved: violation.occurrence_involved_id,
          panel: violation.target,
        },
      });
    },

    onFinalized() {
      this.$message(
        this.$t("occurrence.messages.successTitle"),
        this.$t("occurrence.messages.finalizedSuccess"),
        "success"
      );
      this.showFinalizeModal = false;
      this.resetForm();
      this.loadMapData();
    },

    save() {
      const self = this;
      const e = {};
      if (!self.form.requester_name) e.requester_name = true;
      if (!self.form.requester_phone) e.requester_phone = true;
      if (!self.form.address) e.address = true;
      if (!self.form.complaint) e.complaint = true;
      if (!self.form.discipline_id) e.discipline_id = true;
      if (!self.form.dispatch_type_id) e.dispatch_type_id = true;
      self.errors = e;
      if (Object.keys(e).length > 0) {
        self.$message(
          self.$t("occurrence.messages.attentionTitle"),
          self.$t("occurrence.messages.fillRequiredFields"),
          "error"
        );
        return;
      }

      if (!self.victimsAnswered) {
        self.$message(
          self.$t("occurrence.messages.attentionTitle"),
          self.$t("occurrence.messages.answerVictimsQuestion"),
          "error"
        );
        self.showVictimsModal = true;
        return;
      }

      if (
        self.pendingInterrogatory &&
        self.pendingInterrogatoryRequired &&
        !self.pendingInterrAnswers
      ) {
        self.$message(
          self.$t("occurrence.messages.mandatoryInterrogatoryTitle"),
          self.$t("occurrence.messages.answerInterrogatory"),
          "error"
        );
        self.showInterrogatoryModal = true;
        return;
      }

      self.$loading(true);
      const saveRequest = self.currentOccurrenceId
        ? axios.put(
            `${self.$store.state.api}occurrences/${self.currentOccurrenceId}`,
            { ...self.form }
          )
        : axios.post(`${self.$store.state.api}occurrences`, self.form);

      saveRequest
        .then((r) => {
          const occurrence = r.data.data || r.data;
          const occurrenceId = occurrence.id || self.currentOccurrenceId;

          // Avança o step no pipeline (solicita → próximo → ... → despacha)
          return self
            .runGuarded((options) =>
              axios.post(
                `${self.$store.state.api}occurrences/${occurrenceId}/forward`,
                options
              )
            )
            .then((passou) => {
              if (!passou) return null;

              const protocol =
                occurrence.protocol || self.currentProtocol || "";
              return { occurrenceId, protocol };
            });
        })
        .then((avancou) => {
          if (!avancou) return null;

          const { occurrenceId, protocol } = avancou;
          const successMsg = protocol
            ? self.$t("occurrence.messages.forwardedSuccessWithProtocol", {
                protocol,
              })
            : self.$t("occurrence.messages.forwardedSuccess");

          // Encadeia o salvamento do interrogatório (se houver) e dos envolvidos
          let chain = Promise.resolve();

          if (self.pendingInterrAnswers && self.pendingInterrogatory) {
            chain = chain.then(() =>
              axios
                .post(`${self.$store.state.api}occurrence_interrogatories`, {
                  occurrence_id: occurrenceId,
                  interrogatory_id: self.pendingInterrogatory.id,
                  answers: self.pendingInterrAnswers.answers,
                })
                .catch(() => {
                  self.$message(
                    self.$t("occurrence.messages.successTitle"),
                    `${successMsg}<br>${self.$t(
                      "occurrence.messages.interrogatorySaveFailed"
                    )}`,
                    "warning"
                  );
                })
            );
          }

          if (self.pendingInvolveds.length > 0) {
            chain = chain.then(() => {
              const involvedPromises = self.pendingInvolveds.map((inv) => {
                const payload = {
                  occurrence_id: occurrenceId,
                  entity_type: inv.entity_type,
                  involved_role_id: inv.involved_role_id,
                };
                if (inv.entity_id) {
                  payload.entity_id = inv.entity_id;
                } else {
                  payload.entity = inv.entity;
                }
                return axios.post(
                  `${self.$store.state.api}occurrence_involveds`,
                  payload
                );
              });
              return Promise.allSettled(involvedPromises).then((results) => {
                const failed = results.filter(
                  (r) => r.status === "rejected"
                ).length;
                if (failed > 0) {
                  self.$message(
                    self.$t("occurrence.messages.successTitle"),
                    `${successMsg}<br>${self.$t(
                      "occurrence.messages.involvedsSaveFailed",
                      { failed }
                    )}`,
                    "warning"
                  );
                }
              });
            });
          }

          return chain.then(() => {
            self.$message(
              self.$t("occurrence.messages.successTitle"),
              successMsg,
              "success"
            );
          });
        })
        .then(() => {
          self.resetForm();
          self.loadMapData();
        })
        .catch((err) => {
          self.$message(
            null,
            err.response?.data || self.$t("occurrence.messages.forwardError"),
            "error"
          );
        })
        .finally(() => self.$loading(false));
    },

    resetForm() {
      this.form = {
        requester_name: "",
        requester_phone: "",
        address: "",
        reference_point: "",
        number: "",
        neighborhood: "",
        city: "",
        state: "",
        complement: "",
        zip_code: "",
        latitude: null,
        longitude: null,
        dispatch_type_id: null,
        dispatch_reason_id: null,
        discipline_id: null,
        complaint: "",
        victims_count: null,
        victims_status: null,
      };
      this.nearbyOccurrenceIds = [];
      this.phoneHistory = null;
      this.phoneHistoryDismissed = false;
      this.improvedComplaintSnapshot = "";
      this.suggestedClassificationSnapshot = "";
      this.suggestedDispatchReasonId = null;
      this.dispatchReasons = [];
      this.pendingInterrogatory = null;
      this.pendingInterrogatoryRequired = false;
      this.pendingInterrAnswers = null;
      this.interrReviewAnswers = [];
      this.pendingInvolveds = [];
      this.showVictimsModal = false;
      this.victimsAnswered = false;
      this.victimsAnswer = null;
      this.showMotivo = false;
      this.currentOccurrenceId = null;
      this.currentProtocol = "";
      this.currentOccurrenceCreatedAt = null;
      this.creatingOccurrence = false;
      this.phoneCreateError = false;
      this.showFinalizeModal = false;
      this.errors = {};
      if (
        this.$refs.autocomplete &&
        this.$refs.autocomplete.$refs &&
        this.$refs.autocomplete.$refs.input
      ) {
        this.$refs.autocomplete.$refs.input.value = "";
      }
    },

    onListModalShow() {
      this.pagination.current_page = 1;
      this.occurrences = [];
      this.filters.status = "1";
      this.fetchOccurrences();
    },

    limparFiltros() {
      this.filters = {
        discipline_id: null,
        dispatch_type_id: null,
        date_from: "",
        date_to: "",
        status: "",
        protocol: "",
      };
      this.fetchOccurrences();
    },

    alternarOrdem() {
      this.listSort = this.listSort === "desc" ? "asc" : "desc";
      this.fetchOccurrences();
    },

    situacao(occ) {
      const st = Number(occ.status);

      if (st === 1)
        return {
          rotulo: this.$t("occurrence.list.status.open"),
          classe: "badge badge-success",
        };
      if (st === 2)
        return {
          rotulo: this.$t("occurrence.list.status.finalized"),
          classe: "badge badge-primary",
        };

      return {
        rotulo: this.$t("occurrence.list.status.draft"),
        classe: "badge badge-light border",
      };
    },

    duracao(occ) {
      if (!occ.created_at) return { texto: "—", classe: "text-muted" };

      const inicio = new Date(occ.created_at).getTime();
      const aberta = Number(occ.status) === 1;
      let fim = null;

      if (aberta) {
        fim = this.elapsedNow;
      } else if (occ.finalized_at) {
        fim = new Date(occ.finalized_at).getTime();
      }

      if (fim === null) return { texto: "—", classe: "text-muted" };

      const texto = this.duracaoLonga(
        Math.max(0, Math.floor((fim - inicio) / 1000))
      );

      if (!aberta) return { texto, classe: "text-muted" };

      const horas = (fim - inicio) / 3600000;
      const openSince = this.$t("occurrence.list.duration.openSince", {
        duration: texto,
      });
      if (horas >= 24) return { texto: openSince, classe: "text-danger" };
      if (horas >= 4) return { texto: openSince, classe: "text-warning" };

      return { texto: openSince, classe: "text-muted" };
    },

    duracaoLonga(segundos) {
      const dias = Math.floor(segundos / 86400);
      const horas = Math.floor((segundos % 86400) / 3600);
      const min = Math.floor((segundos % 3600) / 60);

      if (dias > 0) {
        const diaLabel =
          dias === 1
            ? this.$t("occurrence.duration.day")
            : this.$t("occurrence.duration.days");
        return `${dias} ${diaLabel}${horas ? ` ${horas}h` : ""}`;
      }
      if (horas > 0) return `${horas}h${min ? ` ${min}min` : ""}`;

      return `${min}min`;
    },

    horaCurta(iso) {
      if (!iso) return "—";
      return new Date(iso).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    formatDateTime(iso) {
      if (!iso) return "—";
      return new Date(iso).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    diaLongo(iso) {
      if (!iso) return this.$t("occurrence.list.noDate");
      return new Date(iso).toLocaleDateString("pt-BR", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },

    verOcorrencia(occ) {
      this.detailOccurrenceId = occ.id;
      this.showDetailModal = true;
    },

    irParaOperacional(occ) {
      const nome =
        occ.current_step === "regulacao"
          ? "regulacao-detail"
          : "despacho-detail";
      this.$router.push({ name: nome, params: { id: occ.id } });
    },

    fetchOccurrences() {
      const self = this;
      const { api } = self.$store.state;
      const params = new URLSearchParams({
        paginated: true,
        page: self.pagination.current_page,
        per_page: self.pagination.per_page,
        context: "ocorrencia",
      });

      params.append("with[]", "dispatchType");
      params.append("with[]", "dispatchReason");
      params.append("with[]", "discipline");

      if (self.filters.discipline_id)
        params.append("discipline_id", self.filters.discipline_id);
      if (self.filters.dispatch_type_id)
        params.append("dispatch_type_id", self.filters.dispatch_type_id);
      if (self.filters.date_from)
        params.append("date_from", self.filters.date_from);
      if (self.filters.date_to) params.append("date_to", self.filters.date_to);
      if (self.filters.status !== "")
        params.append("status", self.filters.status);
      if (self.filters.protocol)
        params.append("protocol", self.filters.protocol.trim());

      params.append(
        self.listSort === "desc" ? "orderByDesc" : "orderByAsc",
        "created_at"
      );

      self.$loading(true);
      axios
        .get(`${api}occurrences?${params.toString()}`)
        .then((r) => {
          const { data } = r.data;
          if (data.data) {
            self.occurrences = data.data;
            self.pagination.total = data.total;
            self.pagination.per_page = data.per_page;
            self.pagination.last_page = data.last_page;
            self.pagination.current_page = data.current_page;
          } else {
            self.occurrences = data;
          }
        })
        .catch(() => {})
        .finally(() => self.$loading(false));
    },
  },
};
</script>

<style scoped>
.phone-input-wrap {
  position: relative;
}

.phone-input-wrap .form-control.has-trote-icon {
  padding-right: 34px;
  /* Some bootstrap-vue "invalid" ícone embutido (fica atrás do nosso). */
  background-image: none;
}

.phone-trote-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #dc3545;
  pointer-events: none;
}

.phone-history-balloon {
  /* Posição calculada em JS (positionPhoneBalloon) via getBoundingClientRect
     do input — fixed escapa do overflow-y:auto do painel lateral, então o
     balão sobrepõe o mapa ao lado em vez de forçar scroll horizontal nele. */
  position: fixed;
  z-index: 30;
  display: flex;
  align-items: flex-start;
  width: 280px;
  max-width: calc(100vw - 40px);
  padding: 10px 28px 10px 12px;
  border-radius: 8px;
  font-size: 0.78rem;
  line-height: 1.4;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
}

/* Setinha apontando pro campo, agora à esquerda do balão */
.phone-history-balloon::before {
  content: "";
  position: absolute;
  top: 14px;
  left: -6px;
  width: 12px;
  height: 12px;
  background-color: inherit;
  transform: rotate(45deg);
  border-radius: 2px;
}

.phone-history-balloon__icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.duplicate-occ-card {
  position: fixed;
  z-index: 30;
  width: 340px;
  max-width: calc(100vw - 40px);
  background: #fff;
  border: 1px solid #ffe1b3;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  font-size: 0.8rem;
  overflow: hidden;
}

.duplicate-occ-card__header {
  display: flex;
  align-items: center;
  background: #fff6e6;
  color: #a85d00;
  font-weight: 600;
  padding: 8px 12px;
  border-bottom: 1px solid #ffe1b3;
}

.duplicate-occ-card__body {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: #333;
}

.duplicate-occ-card__situation {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: bold;
}

.duplicate-occ-card__situation.is-aberta {
  background: #fff3cd;
  color: #8a6400;
}
.duplicate-occ-card__situation.is-aguardando_despacho {
  background: #ffe5c2;
  color: #96500a;
}
.duplicate-occ-card__situation.is-despachado {
  background: #d4edda;
  color: #155724;
}

.duplicate-occ-card__actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px 10px;
}

.duplicate-occ-card__main-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duplicate-occ-card__secondary-actions {
  display: flex;
  gap: 6px;
}

.duplicate-occ-card__secondary-actions .btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duplicate-occ-card__link-btn {
  align-self: center;
  color: #6e6b7b;
  padding: 2px;
}

.duplicate-occ-card__annotation {
  padding: 0 12px 10px;
}

.phone-history-balloon__text {
  flex: 1;
  min-width: 0;
}

.phone-history-balloon__close {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
}

.phone-history-balloon__close:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.08);
}

.phone-history-balloon--danger {
  background: #fdeaea;
  color: #b91c1c;
}

.dark-layout .phone-history-balloon--danger {
  background: #3a1c1c;
  color: #f87171;
}

.dark-layout .phone-history-balloon__close:hover {
  background: rgba(255, 255, 255, 0.12);
}

.phone-balloon-fade-enter-active,
.phone-balloon-fade-leave-active {
  transition: opacity 0.15s, transform 0.15s;
}

.phone-balloon-fade-enter,
.phone-balloon-fade-leave-to {
  opacity: 0;
  transform: translateX(-4px);
}

.occ-list__day td {
  background: #f6f7fb;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  padding-top: 6px;
  padding-bottom: 6px;
}

.dark-layout .occ-list__day td {
  background: #232a3d;
  color: #b4b7bd;
}

.occ-list__row--clickable {
  cursor: pointer;
}

.occ-list td {
  vertical-align: middle;
}

.vselect--sm ::v-deep .vs__dropdown-toggle {
  min-height: 31px;
  padding-top: 0;
  padding-bottom: 0;
}

.occurrence-page {
  position: relative;
  width: 100%;
  /*
   * 100vh minus:
   *   navbar + content-padding-top + floating-nav-margin = 7.75rem
   *   breadcrumb row                                     = ~3.4rem
   *   footer                                             = 3.35rem
   *   Total                                              ~ 14.5rem → 15rem safe
   */
  height: calc(100vh - 15rem);
  overflow: hidden;
  border-radius: 0.428rem;
}

/* Menu flutuante do mapa (Funcionalidades: centralizar / rótulo) */
.map-menu {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.map-menu-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #d7dee3;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.25);
  color: #33424d;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 11px;
  cursor: pointer;
}

.map-menu-toggle:hover {
  background: #f2f6f8;
}

.map-menu-toggle.is-on {
  background: #28c76f;
  border-color: #28c76f;
  color: #ffffff;
}

.poi-video {
  width: 100%;
  height: 220px;
  background: #000;
  border-radius: 6px;
}

.poi-camera-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 160px;
  background: #f3f2f7;
  border: 1px dashed #d7dee3;
  border-radius: 6px;
  color: #82868b;
  font-size: 13px;
  text-align: center;
}

.map-menu-panel {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 190px;
  background: #ffffff;
  border: 1px solid #d7dee3;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
  overflow: hidden;
}

.map-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: none;
  border: 0;
  border-bottom: 1px solid #eef2f4;
  color: #33424d;
  font-size: 12.5px;
  font-weight: 600;
  padding: 9px 12px;
  text-align: left;
  cursor: pointer;
}

.map-menu-item:last-child {
  border-bottom: 0;
}

.map-menu-item:hover {
  background: #f2f6f8;
}

.map-menu-item.is-on {
  color: #28c76f;
}

.map-menu-caret {
  margin-left: auto;
  opacity: 0.7;
}

.map-menu-sub {
  background: #f7fafb;
  border-bottom: 1px solid #eef2f4;
}

.map-menu-sub-item {
  display: block;
  width: 100%;
  background: none;
  border: 0;
  border-bottom: 1px solid #eef2f4;
  color: #33424d;
  font-size: 12.5px;
  padding: 8px 12px 8px 32px;
  text-align: left;
  cursor: pointer;
}

.map-menu-sub-item:last-child {
  border-bottom: 0;
}

.map-menu-sub-item:hover {
  background: #eaf1f3;
}

.map-menu-sub-item.is-active {
  background: #28c76f;
  color: #ffffff;
}

.map-menu-sub-item.is-clear {
  border-top: 1px solid #d7dee3;
  color: #a4322c;
  font-weight: 600;
}

.occ-panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 380px;
  background: #fff;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  z-index: 1;
  overflow: hidden;
}

.occ-panel__header {
  padding: 16px 20px 10px;
  border-bottom: 1px solid #eee;
  background: #fff;
  flex-shrink: 0;
}

.occ-panel__title {
  display: inline-flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
}

.occ-panel__title--creating {
  color: #aaa;
}

.occ-panel__title--open {
  color: #e07b00;
}

.occ-open-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff0f0;
  border-left: 3px solid #dc3545;
  border-radius: 6px;
  padding: 6px 10px;
  width: 100%;
}

.occ-open-error__msg {
  display: inline-flex;
  align-items: center;
  font-size: 0.82rem;
  font-weight: 600;
  color: #dc3545;
}

.occ-open-error__retry {
  background: none;
  border: 1px solid #dc3545;
  border-radius: 5px;
  color: #dc3545;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  transition: background 0.15s;
}

.occ-open-error__retry:hover {
  background: rgba(220, 53, 69, 0.08);
}

.occ-panel__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 20px;
}

.occ-panel__footer {
  padding: 12px 20px 16px;
  border-top: 1px solid #eee;
  background: #fff;
  flex-shrink: 0;
}

/* Botão flutuante centralizado na base do mapa */
.occ-list-fab {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  padding: 10px 28px;
  background: #fff;
  border: 1px solid #d8d6de;
  border-radius: 50px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  font-size: 0.95rem;
  cursor: pointer;
  white-space: nowrap;
  transition: box-shadow 0.2s;
}

.occ-list-fab:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.28);
}

.required {
  color: #dc3545;
}

/*
 * Ate 991px o painel deixa de flutuar sobre o mapa e passa a empilhar acima
 * dele: num telefone de 375px, um painel absoluto de 380px cobre o mapa
 * inteiro. Acima desse ponto nada muda — a estetica de desktop e a mesma.
 */
.is-invalid-vselect :deep(.vs__dropdown-toggle) {
  border-color: #dc3545;
}

/* Garante que o input do GmapAutocomplete herde o estilo do Bootstrap */
:deep(.pac-target-input) {
  width: 100%;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 0.438rem 1rem;
  font-size: 1rem;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}

:deep(.pac-target-input:focus) {
  border-color: #7367f0;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}

.interr-done-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e7faf0;
  border-left: 3px solid #28c76f;
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 0.85rem;
}

.interr-done-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: #28c76f;
  white-space: nowrap;
}

.interr-done-btn {
  background: none;
  border: 1px solid #28c76f;
  border-radius: 5px;
  color: #28c76f;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: background 0.15s;
  white-space: nowrap;
}

.interr-done-btn:hover {
  background: rgba(40, 199, 111, 0.1);
}
</style>
<style>
/* Rótulo do pin de ocorrência no mapa — não escopado de propósito: o
   Google Maps renderiza este elemento fora da árvore do componente Vue. */
.occ-map-pin-label {
  position: relative;
  display: inline-block;
  background: #ffffff;
  border: 1.5px solid #1a73e8;
  border-radius: 7px;
  padding: 3px 10px;
  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.3);
  white-space: nowrap;
  letter-spacing: 0.15px;
}
.occ-map-pin-label::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -7px;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #1a73e8;
}
.occ-map-pin-label::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
}
</style>
